// @ts-nocheck
export default {
    SET_BETWEEN_DATE: (state, betweenDate) => {
        state.betweenDate = betweenDate;
    },
    GET_BASIC_BAROMONEY_REPORT: (state, tableItems) => {
        state.tableItems = tableItems;
    },
};
